import React from 'react';

/**
 * Botón global reutilizable de RedCimarrona.
 * No reemplaza masivamente los .btn existentes: se adopta donde aporta.
 *
 * variantes: primary | secondary | success | danger | ghost | outline | link | icon
 * sizes: sm | md | lg
 * loading: muestra spinner y bloquea clics
 */
const VARIANT_CLASS = {
  primary: 'btn-v',
  secondary: 'btn-a',
  success: 'btn-s',
  danger: 'btn-r',
  ghost: 'btn-ghost',
  outline: 'btn-outline-v',
  link: 'btn-link',
  icon: 'btn-v btn-icon',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  full = false,
  type = 'button',
  className = '',
  children,
  ...rest
}) {
  const classes = [
    'btn',
    VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
    size === 'sm' ? 'btn-sm' : size === 'lg' ? 'btn-lg' : '',
    full ? 'btn-full' : '',
    loading ? 'btn-loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {children}
    </button>
  );
}
